import { FiltersMap } from '../model';
import { CollectionState } from './CollectionState';
import { action, makeObservable } from 'mobx';

export class CollectionOptimisticProcessorHelpers<T, F extends FiltersMap> {
  readonly collection: CollectionState<T, F>;
  constructor(collection: CollectionState<T, F>) {
    this.collection = collection;

    makeObservable(this, {
      reprocess: action.bound,
      commit: action,
    });
  }

  reprocess() {
    const { collection } = this;
    const { result } = collection;
    const {
      _pages: { unprocessed: unprocessedPages },
      _totals: { unprocessed: unprocessedTotal },
    } = result;

    const { processedTotal, processedPages } = collection._getProcessedResult({
      unprocessedPages,
      unprocessedTotal,
      currentItemsMap: new Map(),
    });

    result.setTotals({
      unprocessed: unprocessedTotal,
      processed: processedTotal,
    });

    result.setPages({
      unprocessed: unprocessedPages,
      processed: processedPages,
    });
  }

  commit() {
    const { collection } = this;
    const { result } = collection;
    const {
      _pages: { processed: processedPages },
      _totals: { processed: processedTotal },
    } = result;

    result._totals.unprocessed = processedTotal;
    result._pages.unprocessed = processedPages;
  }
}
